import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=4d6e55ac&scoped=true&"
import script from "./RatingInput.vue?vue&type=script&lang=js&"
export * from "./RatingInput.vue?vue&type=script&lang=js&"
import style0 from "./RatingInput.vue?vue&type=style&index=0&id=4d6e55ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e55ac",
  null
  
)

export default component.exports